(function($, _) {
  var ns = window.nspace("ccc.viz.map.views");

  /**
   * The "select a region from the map" prompt that appears when no location is selected
   */
  ns.SelectRegionPromptView = Backbone.View.extend({
    el: "#select-region-prompt-container",
    name: "Select a Region prompt",

    initialize: function() {
      _.bindAll(this, "render");

      this.initialRenderPromise = $.Deferred();

      this.model.on("change:selectedFips change:locationTypeId", this.render);
      // Toggle the prompt the first time we come to the page.
      this.model.once("change", this.render);
      this.render();
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    render: function() {
      var self = this;

      // Verify this selector's container is present
      if (this.$el.length === 0) {
        throw "Could not find the " + this.name + " container: " + this.el;
      }

      if (
        +this.model.get("locationTypeId") ===
        ccc.viz.map.config.MapConfig.nycLocationId
      ) {
        self.$el.hide();
        self.initialRenderPromise.resolve();
        return;
      }

      var fips = this.model.get("selectedFips");
      if (!fips || fips === "a") {
        self.$el.hide().fadeIn(function() {
          self.initialRenderPromise.resolve();
        });
      }
      else {
        self.$el.hide();
        self.initialRenderPromise.resolve();
      }
    }
  });
})(jQuery, _);
